<template>
  <div class="contact">
    <br />
    <h2 align="center">Contact us</h2>
    <br />

    <contact-form />

    <br />
    <br />
  </div>
</template>

<script>
export default {
  name: 'contact'
}
</script>
